/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCameraOff = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m1.707.293 22 22-1.414 1.414L20.586 22H1V5h2.586L.293 1.707zm3.878 6.706H3v13h15.585l-3.264-3.264A4.98 4.98 0 0 1 12.001 18c-2.758 0-5-2.243-5-5a4.98 4.98 0 0 1 1.264-3.32zM15.535 2l2 3H23v13.586l-2-2V6.999h-4.535l-2-2.999H9.536l-.45.673L7.645 3.23 8.465 2zm-5.852 9.097A2.986 2.986 0 0 0 9 13c0 1.654 1.346 3 3 3 .722 0 1.385-.256 1.903-.682zm7.299 1.471a4.997 4.997 0 0 0-.023-.21z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCameraOff as CameraOff };
